    // Dropdown options - Status options are hardcoded
 export const statusOptions: Array<{ uuid: string; name: string }> = [
    { uuid: '3d8b53f5-11e2-4f8b-9d3b-bb86dcd1e643', name: 'Pending' },
    { uuid: '3d8b53f5-11e2-4f8b-9d3b-bb86dcd1e644', name: 'Approved' },
    { uuid: '3d8b53f5-11e2-4f8b-9d3b-bb86dcd1e645', name: 'Rejected' },
    { uuid: '3d8b53f5-11e2-4f8b-9d3b-bb86dcd1e646', name: 'Processed' }
  ];  

   export const paymentStatusOptions: Array<{ uuid: string; name: string }> = [
    { uuid: '3d8b53f5-11e2-4f8b-9d3b-bb86dcd1e640', name: 'Pending' },
    { uuid: '3d8b53f5-11e2-4f8b-9d3b-bb86dcd1e641', name: 'Approved' },
    { uuid: '3d8b53f5-11e2-4f8b-9d3b-bb86dcd1e642', name: 'Rejected' },
  ];
     